import { render, staticRenderFns } from "./ComponentLoader.vue?vue&type=template&id=31ede3bc&"
import script from "./ComponentLoader.vue?vue&type=script&lang=ts&"
export * from "./ComponentLoader.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentLoader.vue?vue&type=style&index=0&id=31ede3bc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports